import React, { useCallback } from 'react';
import { RoadmapIntervals } from '@atlassian/jira-software-roadmap-timeline-table-kit';
import type { Interval } from '@atlassian/jira-software-roadmap-timeline-table-kit/src/types';
import RoadmapSprintFlyoutAsync from './flyout/async';

type Props = {
	intervals: ReadonlyArray<Interval>;
};

const RoadmapIntervalsHeader = ({ intervals }: Props) => {
	const renderPopupContent = useCallback(
		(selectedIntervals: ReadonlyArray<Interval>) => (
			<RoadmapSprintFlyoutAsync intervals={selectedIntervals} />
		),
		[],
	);

	return <RoadmapIntervals intervals={intervals} renderPopupContent={renderPopupContent} />;
};

export default RoadmapIntervalsHeader;
